import { render, staticRenderFns } from "./SubKategoriPenyaluranDana.vue?vue&type=template&id=500aea64"
import script from "./SubKategoriPenyaluranDana.vue?vue&type=script&lang=js"
export * from "./SubKategoriPenyaluranDana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports